import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslocoUtils } from '@aodocs/shared-translation';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'aodocs-google-sign-in',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  providers: [
    provideTranslocoScope({
      scope: 'authentication',
      loader: TranslocoUtils.loader((lang) => import(`../../../assets/i18n/lib/authentication/authentication-${lang}.json`)),
    }),
  ],
  templateUrl: './google-sign-in.component.html',
  styleUrls: ['./google-sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleSignInComponent {
  @Output() clickEvent = new EventEmitter<void>();
}
